import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";

/*
 *  Organization User Management Services
 * !== 기관 사용자 관리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/usr/orgusr`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/usr/orgusr/org-usr-mgmt`,
    nodes: [],
};

export const URLS = {
    osci0103010q: `${BASE.path}/osci0103010q`, // Organization User List !==  기관 사용자 목록 ==!
    osci0103011s: `${BASE.path}/osci0103011s`, // Organization User Registration !==  기관 사용자  등록 ==!
    osci0103012s: `${BASE.path}/osci0103012s`, // Modifying and deleting Organization User!==  기관 사용자 수정 및 삭제 ==!
    osci0103013q: `${BASE.path}/osci0103013q`, // Organization User Detail !==  기관 사용자 상세 ==!
    osci0103014q: `${BASE.path}/osci0103014q`, // Organization User List !==  기관 사용자 목록 ==!
    osci0103015s: `${BASE.path}/osci0103015s`, // Organization User Registration !==  기관 사용자  등록 ==!
    osci0103016s: `${BASE.path}/osci0103016s`, // Modifying and deleting Organization User!==  기관 사용자 수정 및 삭제 ==!
    osci0103017q: `${BASE.path}/osci0103017q`, // Organization User Detail !==  기관 사용자 상세 ==!
};

export const APIS = {
    // Check Organization User List !==  기관 사용자 목록 조회 ==!
    getOrgUsrList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Check Organization User information !==  기관 사용자 정보 조회 ==!
    getOrgUsrInfo: (id: any) => {
        return api.get(`${BASE.api}/${id}`);
    },

    // Create Organization User information !==  기관 사용자 정보 등록 ==!
    createOrgUsrInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // update Organization information !==  기관 정보 수정 ==!
    updateOrgUsrInfo: (data: any) => {
        return api.put(`${BASE.api}`, { ...data });
    },
    //delete Organization User information !== 기관 사용자 정보 삭제 ==!
    deleteOrgUsrInfo: (usrIdntfId: any) => {
        return api.delete(`${BASE.api}/${usrIdntfId}`);
    },

    // !== 기관 사용자 비밀번호를 초기화한다. ==!
    updateOrgUsrPwdInit: (data: any) => {
        return api.put(`${BASE.api}/pwd-init`, {
            ...data,
        });
    },

    // User duplicate check !== 사용자 중복 체크 ==!
    getUsrDuplCheck: (usrIdntfNo: any) => {
        return api.put(`${BASE.api}/getUsrDuplCheck`, { usrIdntfNo: usrIdntfNo });
    },

    // Check Organization Representative Auth list !== 기관 대표자 권한 목록 조회 ==!
    getOgaUsrAuthList: ({ usrIdntfId, ...rest }: any, page: number, size: number) => {
        return api.get(`${BASE.api}/${usrIdntfId}/auth?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(rest),
        });
    },
};

/*
 * Authorities managed by the system according to the representative flag.
 * !== 대표자 여부에 따라 시스템이 부여/회수하는 권한 ==!
 * auth_osci0001(OGA User) : granted to every user
 * auth_osci0002(OGA Representative) : granted only while the user is the representative
 * They are excluded from the auth search popup (ADM_AUTH_YN = 'Y'), so blocking deletion
 * keeps them from being changed by hand.
 * !== 권한 조회 팝업에서도 조회되지 않으므로 삭제만 막으면 임의 변경이 차단된다 ==!
 */
export const FIXED_USR_AUTH_IDS = ["auth_osci0001", "auth_osci0002"];

/*
 * [2026-10-30] One Stop Centre 기관 코드.
 * 이 기관 소속 사용자에게는 관리자 권한(auth_osci0003) 만 부여할 수 있다.
 * 기존에는 이 코드가 화면·매퍼 곳곳에 문자열로 흩어져 있어 여기에 상수로 둔다.
 */
export const OSC_ORG_CD = "OGAZ0037";

/* [2026-10-30] One Stop Centre 소속 사용자에게 부여 가능한 권한 ID */
export const OSC_ORG_ONLY_AUTH_ID = "auth_osci0003";

export const SF_ORG_USR_SRCH: TFormSchema = {
    id: "form_orgSrch",
    schema: {
        orgCd: { type: "code", label: "L_ORG_CD", area: "orgCd", popupSize: "md" },
        usrNm: { type: "text", label: "L_USR_NM" },
        psnTin: { type: "text", label: "L_TIN" },
        usrStatCd: { type: "select", label: "L_STAT", all: true, area: "comnCd", comnCd: "OSC0156" },
        orgRppnYn: {
            type: "select",
            label: "L_ORG_RPPN_YN",
            options: [
                { label: "Head of Organization", value: "Y" },
                { label: "General", value: "N" },
            ],
        },
    },
};

export const SF_ORG_USR_INFO: TFormSchema = {
    id: "form_orgInfo",
    schema: {
        psnTin: { type: "text", label: "L_TIN", required: true },
        orgCd: { type: "code", label: "L_ORG_CD", area: "orgCd", popupSize: "md", required: true },
        frgnrYn: {
            type: "radio",
            label: "L_FRGNR_YN",
            options: [
                { label: "Citizen", value: "N" },
                { label: "Foreigner", value: "Y" },
            ],
            defaultValue: "N",
            // required: true,
        },
        aplcCntyCd: { type: "code", label: "L_APLC_CNTY_CD", area: "cntyCd", popupSize: "md", required: true },
        usrNm: { type: "text", label: "L_USR_NM", required: true },
        usrMoblNo: { type: "text", label: "L_USR_MOBL_NO", required: true },
        usrEmlAddr: {
            type: "text",
            label: "L_USR_EML_ADDR",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.osc.00101" },
            required: true,
        },
        rsdtAddr: { type: "text", label: "L_RSDT_ADDR", required: true },
        usrPwd: {
            type: "password",
            label: "L_USR_PWD",
            required: true,
            pattern: {
                value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{10,}$/,
                message: "msg.osc.00225",
            },
        },
        usrPwdCfrm: { type: "password", label: "L_USR_PWD_CFRM", required: true },
        prevUsrAplyId: { type: "text" },
        usrStatCd: { type: "select", label: "L_STAT", all: false, area: "comnCd", comnCd: "OSC0156", required: true },
        deptCd: { type: "code", label: "L_ORG_DEPT", area: "orgDeptCd", popupSize: "md" },
        orgRppnYn: {
            type: "radio",
            label: "L_ORG_RPPN_YN",
            options: [
                { label: "Head of Organization", value: "Y" },
                { label: "General", value: "N" },
            ],
            edit: true,
        },
        mdfyRsn: { type: "textarea", label: "L_MDFY_RSN", controlSize: 10, rows: 5, maxLength: 2000 },
        cstmOfceCd: {
            label: "L_CSTM_OFCE_CD",
            type: "code",
            area: "cstmCd",
            popupSize: "md",
            popupParams: {
                // dclrYn: "Y",
            },
        },
    },
};

export const SG_ORG_USR_LIST: TGridSchema = {
    id: "grid_orgList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_TIN", binding: "psnTin", width: "10%" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "15%" }] },
        { cells: [{ header: "L_ORG_NM", binding: "orgNm", width: "*" }] },
        { cells: [{ header: "L_ORG_RPPN_YN", binding: "orgRppnYn", width: "15%" }] },
        { cells: [{ header: "L_USR_STAT_CD", binding: "usrStatCdNm", width: "10%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
    ],
    body: [
        {
            cells: [{ binding: "psnTin" }],
        },
        {
            cells: [{ binding: "usrNm", align: "left" }],
        },
        {
            cells: [{ binding: "orgNm", align: "left" }],
        },
        {
            cells: [
                {
                    binding: "orgRppnYn",
                    align: "center",
                    type: "radio",
                    viewType: "label",
                    options: [
                        { label: "Head of Organization", value: "Y" },
                        { label: "General", value: "N" },
                    ],
                },
            ],
        },
        {
            cells: [{ binding: "usrStatCdNm", align: "center" }],
        },
        {
            cells: [{ binding: "frstRgsrDtm", type: "datetime" }],
        },
    ],
};

export const SG_USR_AUTH_LIST: TGridSchema = {
    id: "grid_usrAuthList",
    options: { checkbox: true, height: 250 },
    head: [
        { cells: [{ header: "L_AUTH_ID", binding: "authId", width: 150 }] },
        { cells: [{ header: "L_AUTH_NM", binding: "authNm", width: "0.5*" }] },
        { cells: [{ header: "L_AUTH_DESC", binding: "authDesc", width: "0.8*" }] },
        { cells: [{ header: "L_FRST_REGST_ID", binding: "frstRegstId", width: 150 }] },
    ],
    body: [
        { cells: [{ binding: "authId", align: "center" }] },
        { cells: [{ binding: "authNm", align: "left" }] },
        { cells: [{ binding: "authDesc", align: "left" }] },
        { cells: [{ binding: "frstRegstId", align: "center" }] },
    ],
};

// Customs Office Code is a mandatory field for ORG(TBS, ZBS, WMA) !== TBS, ZBS, WMA 기관은 세관 사무소 코드 필수 입력 ==!
// export const CSTM_OFCE_CD_RQRD_ARR = new Array("OGAM0001", "OGAM0035", "OGAZ0001");
